import { UserContext } from "@redotech/redo-merchant-app-common/user";
import { memo, useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

const AB_TEST_USERS = new Set([
  "michael",
  "benjamin",
  "chandler",
  "dev",
  "henry.cho",
  "dallin.webecke",
  "dan.grund",
  "henry.ord",
  "bosley",
  "ben.woodward",
]);
const AB_TEST_DOMAINS = new Set(["redo.com", "getredo.com"]);

/** Storefront A/B tests are limited to the people running them for now. */
export function canAccessAbTests(email: string | null | undefined): boolean {
  const [local, domain, ...rest] = email?.trim().toLowerCase().split("@") ?? [];
  return (
    rest.length === 0 &&
    !!local &&
    !!domain &&
    AB_TEST_USERS.has(local) &&
    AB_TEST_DOMAINS.has(domain)
  );
}

export function useCanAccessAbTests(): boolean {
  const user = useContext(UserContext);
  return canAccessAbTests(user?.email);
}

/** Renders nothing until the user is known, then redirects anyone not allowed. */
export const AbTestAccessGate = memo(function AbTestAccessGate() {
  const user = useContext(UserContext);
  if (!user) {
    return null;
  }
  if (!canAccessAbTests(user.email)) {
    return <Navigate replace to=".." />;
  }
  return <Outlet />;
});
